import { create } from 'zustand';
// Ocean is the default and only preset
export const OCEAN_THEME = {
    name: 'ocean',
    label: 'Ocean',
    colors: {
        '--bg-primary': '#0a1628',
        '--bg-secondary': '#0f2035',
        '--bg-card': 'rgba(255, 255, 255, 0.05)',
        '--text-primary': '#e0f2fe',
        '--text-secondary': '#7db8d8',
        '--accent': '#22d3ee',
        '--accent-2': '#0ea5e9',
        '--gradient-from': '#0891b2',
        '--gradient-to': '#2563eb',
        '--border': 'rgba(34, 211, 238, 0.15)',
        '--nav-bg': 'rgba(10, 22, 40, 0.85)',
    },
};
function applyTheme(colors) {
    const root = document.documentElement;
    Object.entries(colors).forEach(([key, value]) => {
        root.style.setProperty(key, value);
    });
}
function loadStored() {
    try {
        const stored = localStorage.getItem('koggelman_custom_theme');
        if (stored) {
            const parsed = JSON.parse(stored);
            if (parsed.colors)
                return parsed;
        }
    }
    catch { }
    return OCEAN_THEME;
}
const initialTheme = loadStored();
if (typeof document !== 'undefined') {
    applyTheme(initialTheme.colors);
}
export const useThemeStore = create((set, get) => ({
    currentTheme: initialTheme,
    setTheme: (theme) => {
        localStorage.setItem('koggelman_custom_theme', JSON.stringify(theme));
        applyTheme(theme.colors);
        set({ currentTheme: theme });
    },
    resetToOcean: () => {
        localStorage.setItem('koggelman_custom_theme', JSON.stringify(OCEAN_THEME));
        applyTheme(OCEAN_THEME.colors);
        set({ currentTheme: OCEAN_THEME });
    },
    updateColor: (key, value) => {
        const current = get().currentTheme;
        const updated = { ...current, colors: { ...current.colors, [key]: value } };
        applyTheme(updated.colors);
        set({ currentTheme: updated });
    },
    saveCustomTheme: (name) => {
        const current = get().currentTheme;
        const custom = { ...current, name: 'custom', label: name };
        localStorage.setItem('koggelman_custom_theme', JSON.stringify(custom));
        set({ currentTheme: custom });
    },
}));
